export const SIDEBAR_WIDTH = {
  FULL: 260,
  COMPACT: 60,
} as const;
